import React from 'react';
import PropTypes from 'prop-types';

import SelectorInlineOption from "./option";

// eto generic selector UI5 based used in forms i.e. new task dlya vibora task types

export default class SelectorInline extends React.Component {

    static propTypes = {
        items: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.any.isRequired,
                label: PropTypes.string,
                icon: PropTypes.string,
                disabled: PropTypes.bool,
            })
        ).isRequired,
        selectedId: PropTypes.any,  // can be really anythins sometimes string somtimes numebr

        highlightSelected: PropTypes.bool,
        disabled: PropTypes.bool,


        size: PropTypes.number, // default 36 also have 30 , 26

        onChange: PropTypes.func,
    };

    static defaultProps = {
        highlightSelected: true
    }

    state = {
        selectedId: this.props.selectedId
    }

    UNSAFE_componentWillReceiveProps(newProps) {
        if (newProps.selectedId !== this.state.selectedId) {
            this.setState({
                selectedId: newProps.selectedId
            });
        }
    }

    onOptionSelected = (id) => {
        if (this.props.disabled) return;

        this.setState({
            selectedId: id
        },()=> {
            this.props.onChange(id);
        });
    };

    render() {
        const mainClasses = Classes('ui5-selector-inline', this.props.className, {
            "is-disabled": this.props.disabled,
            's-30': (this.props.size===30)
        });

        return (
            <div className={mainClasses}>
                {this.props.items.map((item, key)=><SelectorInlineOption key={key} item={item} selected={this.props.highlightSelected && this.state.selectedId === item.id} onClick={this.onOptionSelected}/>)}
            </div>
        );
    }
}